import React from 'react';
import DocumentDetails from '../../DocumentDetails'
import TestDetails from '../../TestDetails';
import HandleVitalSubmission from '../../HandleVitalSubmission';
import { Row, Col, FormGroup, Label, Input, Button, Card, CardBody, Form } from 'reactstrap';
import HandleSubmission from '../../HandleSubmission';

const BloodSugarForm = (props) => (
  <Card>
    <CardBody>
      <Form onSubmit={props.handleSubmit}>
        <Row>
          <TestDetails 
            date={props.values.date}
            lab={props.values.lab}
            setFieldValue={props.setFieldValue}
            handleChange={props.handleChange}
            errors={props.errors}
            touched={props.touched}
          />
          <Col className="d-flex flex-column">
            <FormGroup>
              <Label>HbA1c</Label>
              <Input type="text" 
                name="hb" 
                value={props.values.hb}
                onChange={props.handleChange}
              />
              {props.errors.hb && props.touched.hb && <div id="feedback" className="text-danger">{props.errors.hb}</div>}
            </FormGroup>
            <FormGroup>
              <Label>Pre Meal Blood Sugar</Label>
              <Input type="text"
                name="preBloodSugar"
                value={props.values.preBloodSugar}
                onChange={props.handleChange}
              />
              {props.errors.preBloodSugar && props.touched.preBloodSugar && <div id="feedback" className="text-danger">{props.errors.preBloodSugar}</div>}
            </FormGroup>
            <FormGroup>
              <Label>Urine Sugar (pp)</Label>
              <Input type="text"
                name="urineSugarPP"
                value={props.values.urineSugarPP}
                onChange={props.handleChange}
              />
              {props.errors.urineSugarPP && props.touched.urineSugarPP && <div id="feedback" className="text-danger">{props.errors.urineSugarPP}</div>}
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label>Post Meal Blood Sugar</Label>
              <Input type="text"
                name="postBloodSugar"
                value={props.values.postBloodSugar}
                onChange={props.handleChange}
              />
              {props.errors.postBloodSugar && props.touched.postBloodSugar && <div id="feedback" className="text-danger">{props.errors.postBloodSugar}</div>}
            </FormGroup>
            <FormGroup>
              <Label>Urine Sugar (f)</Label>
              <Input type="text"
                name="urineSugarF"
                value={props.values.urineSugarF}
                onChange={props.handleChange}
              />
              {props.errors.urineSugarF && props.touched.urineSugarF && <div id="feedback" className="text-danger">{props.errors.urineSugarF}</div>}
            </FormGroup>
          </Col>
        </Row>
        <h5>Document Details</h5>
        <hr />
        <Row>
          <DocumentDetails 
            title={props.values.title}
            description={props.values.description}
            files={props.values.files}
            filesList={props.values.filesList}
            uploadedFiles={props.status.uploadedFiles}
            setFieldValue={props.setFieldValue} 
            handleChange={props.handleChange}
            formType={props.formType}
            deleteImage={props.deleteImage}
            errors={props.errors}
            touched={props.touched}
          />
        </Row>
        <HandleSubmission 
          setFieldValue={props.setFieldValue}
          submitForm={props.submitForm}
          formType={props.formType}
        />
      </Form>
    </CardBody>
  </Card>
)

export default BloodSugarForm;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/PregnancyVitals/PregnancyVitalsView/BloodSugarForm.js